<template>
  <main>
    <div class="py-4 container-fluid">
      <GridRow>
        <GridCol :size="12">
          <MetaSection title="Penilaian KPI">
            <div class="text-right">
              <!-- <div class="d-flex flex-row gap-3">
                <argon-button :outline="true">Kembali</argon-button>
                <argon-button>Kirim</argon-button>
              </div> -->

              <div class="d-flex gap-3">
                <router-link :to="{ name: 'Pengajuan Koreksi' }">
                  <button class="btn btn-secondary">
                    Kembali
                  </button>
                </router-link>

                <template v-if="['submission'].includes(status_koreksi)">
                  <button class="btn-action btn-action--reject" @click="submit(false)">Tolak</button>
                  <button class="btn-action btn-action--primary" @click="submit(true)">Terima</button>
                </template>
                <!-- <button class="btn btn-outline-secondary mr-2">Tolak</button> -->
                <!-- <button class="btn btn-secondary" v-if="!is_correction" @click="setCorrection(true)">Koreksi</button>
                <template v-else>
                  <button class="btn btn-outline-secondary mr-2" @click="setCorrection(false)">Batalkan</button>
                  <button class="btn btn-secondary">Simpan</button>
                </template> -->
              </div>
            </div>
          </MetaSection>
        </GridCol>
        <GridCol :size="12">
            <cards title="Form Realisasi KPI" :withmin="false">
              <div class="d-flex gap-4">
                <div class="bg-secondary rounded-2 p-0" style="width: 92px !important; height: 92px !important; "></div>
                
                <div class="d-flex flex-column gap-3 w-100">
                  <div class="row ">
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">Nama</span>
                      <span>{{ employee?.name || '-' }}</span>
                    </div>
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">Jabatan</span>
                      <span>{{ employee?.jabatan?.name || '-' }}</span>
                    </div>
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">Unit Kerja</span>
                      <span>{{ employee?.unitkerja?.name || '-' }}</span>
                    </div>
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">Direct Supervisor</span>
                      <span>{{ employee?.leader?.name || '-' }}</span>
                    </div>
                  </div>
                  
                  <div class="row">
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">No</span>
                      <span>{{ employee?.nip || '-' }}</span>
                    </div>
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">Posisi</span>
                      <span>{{ employee?.position || '-' }}</span>
                    </div>
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">Periode KPI</span>
                      <span>{{ periode_active?.name || '-' }}</span>
                    </div>
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">Immediate Supervisor</span>
                      <span>{{ employee?.unitkerja?.leader?.name || '-' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </cards>
        </GridCol>
        
        <GridCol :size="12">
            <!-- <cards title="Form Realisasi KPI" useFooter> -->
            <!-- <template v-slot:footer>
              <div class="text-right">
                <div class="d-flex flex-row-reverse gap-2">
                  <ArgonButton>Lanjutkan</ArgonButton>
                  <ArgonButton :to="{ name: 'Realisasi Target' }" isRouteLink outline>Batalkan</ArgonButton>
                </div>
              </div>
            </template> -->

          <cards title="Form Realisasi KPI" class="mt-4">
            <tabbed-pane
              :tabs="tabs"
            >
              <div class="tab-pane fade show active"
                id="pills-penilaian-kinerja"
                role="tabpanel"
                aria-labelledby="pills-penilaian-kinerja-tab"
              >
                <div class="mb-4 d-flex items-center justify-content-between">
                  <h5>Penilaian Kinerja</h5>

                  <button
                    class="btn btn-outline-secondary mb-0"
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#detailListPenilianKinerjaModal"
                  >
                    Lihat Data Sebelumnya
                  </button>
                </div>

                <template v-if="list_penilaian_kinerja?.catatan?.direct?.length > 0">
                  <ArgonAlert
                    v-for="item in list_penilaian_kinerja.catatan.direct"
                    :key="item"
                    title="Catatan Atasan 1"
                    color="primary"
                    :dismissible="false"
                  >
                    <p>{{ item?.catatan || '-' }}</p>
                  </ArgonAlert>
                </template>

                <template v-if="list_penilaian_kinerja?.catatan?.immediate?.length > 0">
                  <ArgonAlert
                    v-for="item in list_penilaian_kinerja.catatan.immediate"
                    :key="item"
                    title="Catatan Atasan 2"
                    color="primary"
                    :dismissible="false"
                  >
                    <p>{{ item?.catatan || '-' }}</p>
                  </ArgonAlert>
                </template>

                <!-- Modal -->
                <div class="modal fade" id="detailListPenilianKinerjaModal" ref="detailListPenilianKinerjaModal" tabindex="-1" aria-labelledby="detailListPenilianKinerjaModalLabel" aria-hidden="true">
                  <div class="modal-dialog modal-dialog-centered modal-xl">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title" id="detailListPenilianKinerjaModalLabel">Penilaian Kinerja</h5>
                        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                          <i class="fa fa-times cursor-pointer" aria-hidden="true"></i>
                        </button> -->
                        <span class="p-1 cursor-pointer" data-bs-dismiss="modal" aria-label="Close">
                          <font-awesome-icon icon="fa-solid fa-times" />
                        </span>
                      </div>
                      <div class="modal-body">
                        <!-- <pre>{{ list_penilaian_kinerja }}</pre> -->
                        <template v-if="list_penilaian_kinerja?.realisasi_kinerja?.list_kpi?.data_lama?.length > 0">
                          <form-group
                            v-for="(item,index) in list_penilaian_kinerja.realisasi_kinerja.list_kpi.data_lama"
                            :key="index"
                            :label="item?.kpi || '-'"
                            :hint="item?.sub_jumlah || item?.sub_jumlah === 0 ? item?.sub_jumlah : (sumBobotSubKpi(item?.sub_kpi || []))"
                          >
                            <div class="table-responsive">
                              <table class="table align-middle border border-1 border-light">
                                <thead class="table-light">
                                  <tr>
                                    <th scope="col">Sub KPI</th>
                                    <th scope="col">Target</th>
                                    <th scope="col">Satuan</th>
                                    <th scope="col">Bobot</th>
                                    <th scope="col">Realisasi</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="(sub, i) in item?.sub_kpi"
                                    :key="i"
                                    class="border border-bottom-1 border-light"
                                  >
                                    <td>
                                      <p>{{ sub?.nama_aspek_kpi || '-' }}</p>
                                      <p v-if="sub?.catatan" class="text-xs"> {{ sub?.catatan || '-' }}</p>
                                    </td>
                                    <td width="150">
                                      <p>
                                        <span v-if="sub?.satuan?.toLowerCase() === 'rupiah'">
                                          {{
                                            new Intl.NumberFormat('id-ID', {
                                              style: 'currency',
                                              currency: 'IDR',
                                              minimumFractionDigits: 0,
                                            }).format(sub?.target || '0')
                                          }}
                                        </span>
                                        <span v-else>
                                          {{
                                            new Intl.NumberFormat('id-ID', {
                                              minimumFractionDigits: 0,
                                            }).format(sub?.target || '0')
                                          }} 
                                          <span class="text-capitalize">{{ (sub?.satuan?.toLowerCase() === 'persen' ? '%' : sub?.satuan) || '' }}</span>
                                        </span>
                                      </p>
                                    </td>
                                    <td width="100">
                                      <p class="text-capitalize">{{ getSatuan(sub?.satuan) || '-' }}</p>
                                    </td>
                                    <td width="100">
                                      <p>{{ sub?.bobot ? sub.bobot +'%' : '-' }}</p>
                                    </td>
                                    <td width="150">
                                      <p>
                                        <span v-if="sub?.satuan?.toLowerCase() === 'rupiah'">
                                          {{
                                            new Intl.NumberFormat('id-ID', {
                                              style: 'currency',
                                              currency: 'IDR',
                                              minimumFractionDigits: 0,
                                            }).format(sub?.realisasi || '0')
                                          }}
                                        </span>
                                        <span v-else>
                                          {{
                                            new Intl.NumberFormat('id-ID', {
                                              minimumFractionDigits: 0,
                                            }).format(sub?.realisasi || '0')
                                          }} 
                                          <span class="text-capitalize">{{ (sub?.satuan?.toLowerCase() === 'persen' ? '%' : sub?.satuan) || '' }}</span>
                                        </span>
                                      </p>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </form-group>
                        </template>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Tutup</button>
                        <!-- <button type="submit" class="btn btn-secondary">Simpan</button> -->
                      </div>
                    </div>
                  </div>
                </div>

                <!-- <pre>{{ list_penilaian_kinerja }}</pre> -->
                <template v-if="list_penilaian_kinerja?.realisasi_kinerja?.list_kpi?.koreksi?.length > 0">
                  <form-group
                    v-for="(item,index) in list_penilaian_kinerja.realisasi_kinerja.list_kpi.koreksi"
                    :key="index"
                    :label="item?.kpi || '-'"
                    :hint="item?.sub_jumlah || item?.sub_jumlah === 0 ? item?.sub_jumlah : (sumBobotSubKpi(item?.sub_kpi || []))"
                  >
                    <div class="table-responsive">
                      <table class="table align-middle border border-1 border-light">
                        <thead class="table-light">
                          <tr>
                            <th scope="col">Sub KPI</th>
                            <th scope="col">Target</th>
                            <th scope="col">Satuan</th>
                            <th scope="col">Bobot</th>
                            <th scope="col">Realisasi</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(sub, i) in item?.sub_kpi"
                            :key="i"
                            class="border border-bottom-1 border-light"
                          >
                            <td>
                              <p>{{ sub?.nama_aspek_kpi || '-' }}</p>
                              <p v-if="sub?.catatan" class="text-xs"> {{ sub?.catatan || '-' }}</p>
                            </td>
                            <td width="150">
                              <p>
                                <span v-if="sub?.satuan?.toLowerCase() === 'rupiah'">
                                  {{
                                    new Intl.NumberFormat('id-ID', {
                                      style: 'currency',
                                      currency: 'IDR',
                                      minimumFractionDigits: 0,
                                    }).format(sub?.target || '0')
                                  }}
                                </span>
                                <span v-else>
                                  {{
                                    new Intl.NumberFormat('id-ID', {
                                      minimumFractionDigits: 0,
                                    }).format(sub?.target || '0')
                                  }} 
                                  <span class="text-capitalize">{{ (sub?.satuan?.toLowerCase() === 'persen' ? '%' : sub?.satuan) || '' }}</span>
                                </span>
                              </p>
                            </td>
                            <td width="100">
                              <p class="text-capitalize">{{ getSatuan(sub?.satuan) || '-' }}</p>
                            </td>
                            <td width="100">
                              <p>{{ sub?.bobot ? sub.bobot +'%' : '-' }}</p>
                            </td>
                            <td width="150">
                              <p>
                                <span v-if="sub?.satuan?.toLowerCase() === 'rupiah'">
                                  {{
                                    new Intl.NumberFormat('id-ID', {
                                      style: 'currency',
                                      currency: 'IDR',
                                      minimumFractionDigits: 0,
                                    }).format(sub?.realisasi || '0')
                                  }}
                                </span>
                                <span v-else>
                                  {{
                                    new Intl.NumberFormat('id-ID', {
                                      minimumFractionDigits: 0,
                                    }).format(sub?.realisasi || '0')
                                  }} 
                                  <span class="text-capitalize">{{ (sub?.satuan?.toLowerCase() === 'persen' ? '%' : sub?.satuan) || '' }}</span>
                                </span>
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </form-group>
                </template>

                <template v-if="['submission'].includes(status_koreksi)">
                  <div
                    v-if="!is_note_penilaian_kinerja"
                    class="d-flex justify-content-end gap-4"
                  >
                    <button
                      type="button"
                      class="btn btn-outline-secondary"
                      @click="is_note_penilaian_kinerja = !is_note_penilaian_kinerja"
                    >
                      Berikan Catatan
                    </button>
                  </div>

                  <form-group
                    v-if="is_note_penilaian_kinerja"
                    label="Tulis Catatan"
                  >
                    <p class="text-sm mb-2">Beri catatan untuk karyawan</p>
                    <textarea
                      v-model="note_penilaian_kinerja"
                      class="form-control"
                      rows="5"
                      placeholder="Tulis catatan disini"
                    />
                  </form-group>
                </template>
              </div>

              <div class="tab-pane fade show"
                id="pills-penugasan-khusus"
                role="tabpanel"
                aria-labelledby="pills-penugasan-khusus-tab"
              >
                
                <div class="mb-4 d-flex items-center justify-content-between">
                  <h5>Penugasan Khusus</h5>
                  <button
                    class="btn btn-outline-secondary mb-0"
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#detailListPenugasanKhususModal"
                  >
                    Lihat Data Sebelumnya
                  </button>
                </div>

                <template v-if="list_penugasan_khusus?.catatan?.direct?.length > 0">
                  <ArgonAlert
                    v-for="item in list_penugasan_khusus.catatan.direct"
                    :key="item"
                    title="Catatan Atasan 1"
                    color="primary"
                    :dismissible="false"
                  >
                    <p>{{ item?.catatan || '-' }}</p>
                  </ArgonAlert>
                </template>

                <template v-if="list_penugasan_khusus?.catatan?.immediate?.length > 0">
                  <ArgonAlert
                    v-for="item in list_penugasan_khusus.catatan.immediate"
                    :key="item"
                    title="Catatan Atasan 2"
                    color="primary"
                    :dismissible="false"
                  >
                    <p>{{ item?.catatan || '-' }}</p>
                  </ArgonAlert>
                </template>

                <!-- Modal -->
                <div class="modal fade" id="detailListPenugasanKhususModal" ref="detailListPenugasanKhususModal" tabindex="-1" aria-labelledby="detailListPenugasanKhususModalLabel" aria-hidden="true">
                  <div class="modal-dialog modal-dialog-centered modal-xl">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title" id="detailListPenugasanKhususModalLabel">Penugasan Khusus</h5>
                        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                          <i class="fa fa-times cursor-pointer" aria-hidden="true"></i>
                        </button> -->
                        <span class="p-1 cursor-pointer" data-bs-dismiss="modal" aria-label="Close">
                          <font-awesome-icon icon="fa-solid fa-times" />
                        </span>
                      </div>
                      <div class="modal-body">
                        <form-group>
                          <div class="table-responsive">
                            <table class="table align-middle border border-1 border-light">
                              <thead class="table-light">
                                <tr>
                                  <th scope="col" colspan="2">Jenis Penugasan</th>
                                </tr>
                              </thead>
                              <tbody>
                                <template v-if="list_penugasan_khusus?.penugasan?.data_lama?.length > 0">
                                  <tr
                                    v-for="(item) in list_penugasan_khusus.penugasan.data_lama"
                                    :key="item"
                                    class="border border-bottom-1 border-light"
                                  >
                                    <td colspan="2">
                                      <div class="py-3 px-3">{{ item?.name || '-' }}</div>
                                    </td>
                                  </tr>
                                </template>
                                <tr v-else>
                                  <td colspan="2" class="text-center">-</td>
                                </tr>
                              </tbody>
                              <thead class="table-light">
                                <tr>
                                  <th scope="col">Nilai Penugasan Khusus</th>
                                  <th scope="col">{{ list_penugasan_khusus?.penugasan?.data_lama?.length > 0 ? '0.25' : '0' }}</th>
                                </tr>
                              </thead>
                            </table>
                          </div>
                        </form-group>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Tutup</button>
                        <!-- <button type="submit" class="btn btn-secondary">Simpan</button> -->
                      </div>
                    </div>
                  </div>
                </div>

                <!-- <pre>{{ list_penugasan_khusus }}</pre> -->
                <form-group>
                  <div class="table-responsive">
                    <table class="table align-middle border border-1 border-light">
                      <thead class="table-light">
                        <tr>
                          <th scope="col" colspan="2">Jenis Penugasan</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-if="list_penugasan_khusus?.penugasan?.koreksi?.length > 0">
                          <tr
                            v-for="(item) in list_penugasan_khusus.penugasan.koreksi"
                            :key="item"
                            class="border border-bottom-1 border-light"
                          >
                            <td colspan="2">
                              <div class="py-3 px-3">{{ item?.name || '-' }}</div>
                            </td>
                          </tr>
                        </template>
                        <tr v-else>
                          <td colspan="2" class="text-center">-</td>
                        </tr>
                      </tbody>
                      <thead class="table-light">
                        <tr>
                          <th scope="col">Nilai Penugasan Khusus</th>
                          <th scope="col">{{ list_penugasan_khusus?.penugasan?.koreksi?.length > 0 ? '0.25' : '0' }}</th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                </form-group>

                <template v-if="['submission'].includes(status_koreksi)">
                  <div
                    v-if="!is_note_penugasan_khusus"
                    class="d-flex justify-content-end gap-4"
                  >
                    <button
                      type="button"
                      class="btn btn-outline-secondary"
                      @click="is_note_penugasan_khusus = !is_note_penugasan_khusus"
                    >
                      Berikan Catatan
                    </button>
                  </div>

                  <form-group
                    v-if="is_note_penugasan_khusus"
                    label="Tulis Catatan"
                  >
                    <p class="text-sm mb-2">Beri catatan untuk karyawan</p>
                    <textarea
                      v-model="note_penugasan_khusus"
                      class="form-control"
                      rows="5"
                      placeholder="Tulis catatan disini"
                    />
                  </form-group>
                </template>
              </div>

              <div class="tab-pane fade show"
                id="pills-pengurangan"
                role="tabpanel"
                aria-labelledby="pills-pengurangan-tab"
              >
                
                <div class="mb-4 d-flex items-center justify-content-between">
                  <h5>Pengurangan</h5>
                  <button
                    class="btn btn-outline-secondary mb-0"
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#detailListPenguranganModal"
                  >
                    Lihat Data Sebelumnya
                  </button>
                </div>

                <template v-if="list_pengurangan?.catatan?.direct?.length > 0">
                  <ArgonAlert
                    v-for="item in list_pengurangan.catatan.direct"
                    :key="item"
                    title="Catatan Atasan 1"
                    color="primary"
                    :dismissible="false"
                  >
                    <p>{{ item?.catatan || '-' }}</p>
                  </ArgonAlert>
                </template>

                <template v-if="list_pengurangan?.catatan?.immediate?.length > 0">
                  <ArgonAlert
                    v-for="item in list_pengurangan.catatan.immediate"
                    :key="item"
                    title="Catatan Atasan 2"
                    color="primary"
                    :dismissible="false"
                  >
                    <p>{{ item?.catatan || '-' }}</p>
                  </ArgonAlert>
                </template>

                <!-- Modal -->
                <div class="modal fade" id="detailListPenguranganModal" ref="detailListPenguranganModal" tabindex="-1" aria-labelledby="detailListPenguranganModalLabel" aria-hidden="true">
                  <div class="modal-dialog modal-dialog-centered modal-xl">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title" id="detailListPenguranganModalLabel">Pengurangan</h5>
                        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                          <i class="fa fa-times cursor-pointer" aria-hidden="true"></i>
                        </button> -->
                        <span class="p-1 cursor-pointer" data-bs-dismiss="modal" aria-label="Close">
                          <font-awesome-icon icon="fa-solid fa-times" />
                        </span>
                      </div>
                      <div class="modal-body">
                        <form-group>
                          <div class="table-responsive">
                            <table class="table align-middle border border-1 border-light">
                              <thead class="table-light">
                                <tr>
                                  <th scope="col">Tingkat Permasalahan</th>
                                  <th scope="col">Jumlah</th>
                                </tr>
                              </thead>
                              <tbody>
                                <template v-if="list_pengurangan?.pengurangan?.data_lama?.length > 0">
                                  <tr
                                    v-for="(item) in list_pengurangan.pengurangan.data_lama"
                                    :key="item"
                                    class="border border-bottom-1 border-light"
                                  >
                                    <td>
                                      <div class="py-3 px-3">{{ item?.tingkat_permasalahan || '-' }}</div>
                                    </td>
                                    <td width="10">
                                      <span>{{ item?.jumlah_permasalahan || 0 }}</span>
                                    </td>
                                  </tr>
                                </template>
                                <tr v-else>
                                  <td colspan="2" class="text-center">-</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </form-group>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Tutup</button>
                        <!-- <button type="submit" class="btn btn-secondary">Simpan</button> -->
                      </div>
                    </div>
                  </div>
                </div>

                <form-group>
                  <div class="table-responsive">
                    <table class="table align-middle border border-1 border-light">
                      <thead class="table-light">
                        <tr>
                          <th scope="col">Tingkat Permasalahan</th>
                          <th scope="col">Jumlah</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-if="list_pengurangan?.pengurangan?.koreksi?.length > 0">
                          <tr
                            v-for="(item) in list_pengurangan.pengurangan.koreksi"
                            :key="item"
                            class="border border-bottom-1 border-light"
                          >
                            <td>
                              <div class="py-3 px-3">{{ item?.tingkat_permasalahan || '-' }}</div>
                            </td>
                            <td width="10">
                              <span>{{ item?.jumlah_permasalahan || 0 }}</span>
                            </td>
                          </tr>
                        </template>
                        <tr v-else>
                          <td colspan="2" class="text-center">-</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </form-group>

                <template v-if="['submission'].includes(status_koreksi)">
                  <div
                    v-if="!is_note_pengurangan"
                    class="d-flex justify-content-end gap-4"
                  >
                    <button
                      type="button"
                      class="btn btn-outline-secondary"
                      @click="is_note_pengurangan = !is_note_pengurangan"
                    >
                      Berikan Catatan
                    </button>
                  </div>

                  <form-group
                    v-if="is_note_pengurangan"
                    label="Tulis Catatan"
                  >
                    <p class="text-sm mb-2">Beri catatan untuk karyawan</p>
                    <textarea
                      v-model="note_pengurangan"
                      class="form-control"
                      rows="5"
                      placeholder="Tulis catatan disini"
                    />
                  </form-group>
                </template>
              </div>

              <div class="tab-pane fade show"
                id="pills-kompetensi"
                role="tabpanel"
                aria-labelledby="pills-kompetensi-tab"
              >
                <template v-if="realisasi_kompetensi?.catatan?.direct?.length > 0">
                  <ArgonAlert
                    v-for="item in realisasi_kompetensi.catatan.direct"
                    :key="item"
                    title="Catatan Atasan 1"
                    color="primary"
                    :dismissible="false"
                  >
                    <p>{{ item?.catatan || '-' }}</p>
                  </ArgonAlert>
                </template>

                <template v-if="realisasi_kompetensi?.catatan?.immediate?.length > 0">
                  <ArgonAlert
                    v-for="item in realisasi_kompetensi.catatan.immediate"
                    :key="item"
                    title="Catatan Atasan 2"
                    color="primary"
                    :dismissible="false"
                  >
                    <p>{{ item?.catatan || '-' }}</p>
                  </ArgonAlert>
                </template>

                <!-- Modal -->
                <div class="modal fade" id="detailListKompetensiModal" ref="detailListKompetensiModal" tabindex="-1" aria-labelledby="detailListKompetensiModalLabel" aria-hidden="true">
                  <div class="modal-dialog modal-dialog-centered modal-xl">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title" id="detailListKompetensiModalLabel">Kompetensi</h5>
                        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                          <i class="fa fa-times cursor-pointer" aria-hidden="true"></i>
                        </button> -->
                        <span class="p-1 cursor-pointer" data-bs-dismiss="modal" aria-label="Close">
                          <font-awesome-icon icon="fa-solid fa-times" />
                        </span>
                      </div>
                      <div class="modal-body">
                        
                        <!-- <pre>{{ list_kompetensi_inti_old }}</pre> -->
                        <template v-if="list_kompetensi_inti_old.length > 0">
                          <div class="mb-4 d-flex items-center justify-content-between">
                            <h5>Kompetensi Inti</h5>
                            <!-- <button
                              class="btn btn-outline-secondary mb-0"
                              type="button"
                              data-bs-toggle="modal"
                              data-bs-target="#detailListKompetensiModal"
                            >
                              Lihat Data Sebelumnya
                            </button> -->
                          </div>

                          <div
                            v-for="(item) in list_kompetensi_inti_old"
                            :key="item"
                            class="rounded-2 border border-1 p-3 mb-4"
                          >
                            <div class="d-flex justify-content-between items-center">
                              <h6 class="mt-2">{{ item?.kompetensi || '-' }}</h6>
                              <span>{{ item?.nilai || '-' }}</span>
                            </div>

                            <table class="table align-middle border border-1 border-light">
                              <thead class="table-light">
                                <tr>
                                  <th scope="col" style="width: 20px;">
                                    <small>Level</small>
                                  </th>
                                  <th scope="col">
                                    <small>Deskripsi</small>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <template
                                  v-for="(sub, i) in 5"
                                  :key="sub"
                                >
                                  <tr
                                    v-if="item?.list_kompetensi?.['level'+ (i +1)]"
                                    class="border border-bottom-1 border-light"
                                  >
                                    <td>
                                      <span class="px-2">{{ i + 1 }}</span>
                                    </td>
                                    <td>
                                      <p class="mt-3 text-wrap">{{ item?.list_kompetensi?.['level'+ (i +1)] || '-' }}</p>
                                    </td>
                                  </tr>
                                </template>
                              </tbody>
                            </table>
                          </div>
                        </template>

                        <!-- <pre>{{ list_kompetensi_manajerial_old }}</pre> -->
                        <template v-if="list_kompetensi_manajerial_old.length > 0">
                          <div class="mt-5 mb-4 d-flex items-center justify-content-between">
                            <h5>Kompetensi Manajerial</h5>
                            <!-- <button
                              class="btn btn-outline-secondary mb-0"
                              type="button"
                              data-bs-toggle="modal"
                              data-bs-target="#detailListKompetensiModal"
                            >
                              Lihat Data Sebelumnya
                            </button> -->
                          </div>

                          <div
                            v-for="(item) in list_kompetensi_manajerial_old"
                            :key="item"
                            class="rounded-2 border border-1 p-3 mb-4"
                          >
                            <div class="d-flex justify-content-between items-center">
                              <h6 class="mt-2">{{ item?.name || '-' }}</h6>
                              <span>{{ item?.nilai || '-' }}</span>
                            </div>

                            <table class="table align-middle border border-1 border-light">
                              <thead class="table-light">
                                <tr>
                                  <th scope="col" style="width: 20px;">
                                    <small>Level</small>
                                  </th>
                                  <th scope="col">
                                    <small>Deskripsi</small>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <template
                                  v-for="(sub, i) in 5"
                                  :key="sub"
                                >
                                  <tr
                                    v-if="item?.list_kompetensi?.['level'+ (i +1)]"
                                    class="border border-bottom-1 border-light"
                                  >
                                    <td>
                                      <span class="px-2">{{ i + 1 }}</span>
                                    </td>
                                    <td>
                                      <p class="mt-3 text-wrap">{{ item?.list_kompetensi?.['level'+ (i +1)] || '-' }}</p>
                                    </td>
                                  </tr>
                                </template>
                              </tbody>
                            </table>
                          </div>
                        </template>

                        <form-group class="mt-3">
                        <div class="table-responsive">
                          <table class="table align-middle border border-1 border-light">
                            <thead class="table-light">
                              <tr>
                                <th scope="col" class="border-bottom-1 border-white">Jumlah</th>
                                <th scope="col" class="border-bottom-1 border-white">{{ total_nilai_old }}</th>
                              </tr>
                              <tr>
                                <th scope="col" class="border-bottom-1 border-white">Nilai</th>
                                <th scope="col" class="border-bottom-1 border-white" width="60">{{ nilai_kompetensi_old }}</th>
                              </tr>
                              <tr>
                                <th scope="col">Jumlah Maksimal Jabatan</th>
                                <th scope="col">{{ max_jabatan }}</th>
                              </tr>
                            </thead>
                          </table>
                        </div>
                      </form-group>

                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Tutup</button>
                        <!-- <button type="submit" class="btn btn-secondary">Simpan</button> -->
                      </div>
                    </div>
                  </div>
                </div>

                <!-- <pre>{{ list_kompetensi_inti }}</pre> -->
                <template v-if="list_kompetensi_inti.length > 0">
                  <div class="mb-4 d-flex items-center justify-content-between">
                    <h5>Kompetensi Inti</h5>
                    <button
                      class="btn btn-outline-secondary mb-0"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#detailListKompetensiModal"
                    >
                      Lihat Data Sebelumnya
                    </button>
                  </div>

                  <div
                    v-for="(item) in list_kompetensi_inti"
                    :key="item"
                    class="rounded-2 border border-1 p-3 mb-4"
                  >
                    <div class="d-flex justify-content-between items-center">
                      <h6 class="mt-2">{{ item?.kompetensi || '-' }}</h6>
                      <span>{{ item?.nilai || '-' }}</span>
                    </div>

                    <table class="table align-middle border border-1 border-light">
                      <thead class="table-light">
                        <tr>
                          <th scope="col" style="width: 20px;">
                            <small>Level</small>
                          </th>
                          <th scope="col">
                            <small>Deskripsi</small>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <template
                          v-for="(sub, i) in 5"
                          :key="sub"
                        >
                          <tr
                            v-if="item?.list_kompetensi?.['level'+ (i +1)]"
                            class="border border-bottom-1 border-light"
                          >
                            <td>
                              <span class="px-2">{{ i + 1 }}</span>
                            </td>
                            <td>
                              <p class="mt-3 text-wrap">{{ item?.list_kompetensi?.['level'+ (i +1)] || '-' }}</p>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </template>

                <!-- <pre>{{ list_kompetensi_manajerial }}</pre> -->
                <template v-if="list_kompetensi_manajerial.length > 0">
                  <div class="mt-5 mb-4 d-flex items-center justify-content-between">
                    <h5>Kompetensi Manajerial</h5>
                    <button
                      class="btn btn-outline-secondary mb-0"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#detailListKompetensiModal"
                    >
                      Lihat Data Sebelumnya
                    </button>
                  </div>

                  <div
                    v-for="(item) in list_kompetensi_manajerial"
                    :key="item"
                    class="rounded-2 border border-1 p-3 mb-4"
                  >
                    <div class="d-flex justify-content-between items-center">
                      <h6 class="mt-2">{{ item?.name || '-' }}</h6>
                      <span>{{ item?.nilai || '-' }}</span>
                    </div>

                    <table class="table align-middle border border-1 border-light">
                      <thead class="table-light">
                        <tr>
                          <th scope="col" style="width: 20px;">
                            <small>Level</small>
                          </th>
                          <th scope="col">
                            <small>Deskripsi</small>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <template
                          v-for="(sub, i) in 5"
                          :key="sub"
                        >
                          <tr
                            v-if="item?.list_kompetensi?.['level'+ (i +1)]"
                            class="border border-bottom-1 border-light"
                          >
                            <td>
                              <span class="px-2">{{ i + 1 }}</span>
                            </td>
                            <td>
                              <p class="mt-3 text-wrap">{{ item?.list_kompetensi?.['level'+ (i +1)] || '-' }}</p>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </template>

                <template v-if="['submission'].includes(status_koreksi)">
                  <div
                    v-if="!is_note_kompetensi"
                    class="d-flex justify-content-end gap-4"
                  >
                    <button
                      type="button"
                      class="btn btn-outline-secondary"
                      @click="is_note_kompetensi = !is_note_kompetensi"
                    >
                      Berikan Catatan
                    </button>
                  </div>

                  <form-group
                    v-if="is_note_kompetensi"
                    label="Tulis Catatan"
                  >
                    <p class="text-sm mb-2">Beri catatan untuk karyawan</p>
                    <textarea
                      v-model="note_kompetensi"
                      class="form-control"
                      rows="5"
                      placeholder="Tulis catatan disini"
                    />
                  </form-group>
                </template>

                <form-group class="mt-3">
                  <div class="table-responsive">
                    <table class="table align-middle border border-1 border-light">
                      <thead class="table-light">
                        <tr>
                          <th scope="col" class="border-bottom-1 border-white">Jumlah</th>
                          <th scope="col" class="border-bottom-1 border-white">{{ total_nilai }}</th>
                        </tr>
                        <tr>
                          <th scope="col" class="border-bottom-1 border-white">Nilai</th>
                          <th scope="col" class="border-bottom-1 border-white" width="60">{{ nilai_kompetensi }}</th>
                        </tr>
                        <tr>
                          <th scope="col">Jumlah Maksimal Jabatan</th>
                          <th scope="col">{{ max_jabatan }}</th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                </form-group>
              </div>

              <div class="tab-pane fade show"
                id="pills-penilaian-akhir"
                role="tabpanel"
                aria-labelledby="pills-penilaian-akhir-tab"
              >
                
                <div class="mb-4 d-flex items-center justify-content-between">
                  <h5>Penilaian Akhir</h5>
                  <button
                    class="btn btn-outline-secondary mb-0"
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#detailPenilaianAkhirModal"
                  >
                    Lihat Data Sebelumnya
                  </button>
                </div>

                <template v-if="data_penilaian_akhir?.catatan?.direct?.length > 0">
                  <ArgonAlert
                    v-for="item in data_penilaian_akhir.catatan.direct"
                    :key="item"
                    title="Catatan Atasan 1"
                    color="primary"
                    :dismissible="false"
                  >
                    <p>{{ item?.catatan || '-' }}</p>
                  </ArgonAlert>
                </template>

                <template v-if="data_penilaian_akhir?.catatan?.immediate?.length > 0">
                  <ArgonAlert
                    v-for="item in data_penilaian_akhir.catatan.immediate"
                    :key="item"
                    title="Catatan Atasan 2"
                    color="primary"
                    :dismissible="false"
                  >
                    <p>{{ item?.catatan || '-' }}</p>
                  </ArgonAlert>
                </template>

                <!-- Modal -->
                <div class="modal fade" id="detailPenilaianAkhirModal" ref="detailPenilaianAkhirModal" tabindex="-1" aria-labelledby="detailPenilaianAkhirModalLabel" aria-hidden="true">
                  <div class="modal-dialog modal-dialog-centered modal-xl">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title" id="detailPenilaianAkhirModalLabel">Penilaian Akhir</h5>
                        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                          <i class="fa fa-times cursor-pointer" aria-hidden="true"></i>
                        </button> -->
                        <span class="p-1 cursor-pointer" data-bs-dismiss="modal" aria-label="Close">
                          <font-awesome-icon icon="fa-solid fa-times" />
                        </span>
                      </div>
                      <div class="modal-body">
                        <form-group>
                          <div class="table-responsive">
                            <table class="table align-middle border border-1 border-light">
                              <thead class="table-light">
                                <tr>
                                  <th scope="col">Kategori</th>
                                  <th scope="col">Nilai</th>
                                  <th scope="col">Bobot</th>
                                  <th scope="col">Nilai Akhir</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-if="!data_penilaian_akhir"
                                  class="border border-bottom-1 border-light"
                                >
                                  <td colspan="4" class="text-center py-4">Data tidak ditemukan.</td>
                                </tr>

                                <template v-else>
                                  <tr
                                    class="border border-bottom-1 border-light"
                                  >
                                    <td>
                                      <div class="py-3 px-3">Rata-rata Nilai Kinerja</div>
                                    </td>
                                    <td>{{ data_penilaian_akhir?.penilaian_akhir?.data_lama?.nilai_kinerja?.average_kinerja || 0 }}</td>
                                    <td>{{ data_penilaian_akhir?.penilaian_akhir?.data_lama?.nilai_kinerja?.bobot_kinerja ? data_penilaian_akhir?.penilaian_akhir?.data_lama?.nilai_kinerja?.bobot_kinerja +'%' : 0 }}</td>
                                    <td>{{ data_penilaian_akhir?.penilaian_akhir?.data_lama?.nilai_kinerja?.nilai_akhir_kinerja || 0 }}</td>
                                  </tr>
                                  <tr
                                    class="border border-bottom-1 border-light"
                                  >
                                    <td>
                                      <div class="py-3 px-3">Rata-rata Perilaku Kompetensi</div>
                                    </td>
                                    <td>{{ data_penilaian_akhir?.penilaian_akhir?.data_lama?.kompetensi?.average_kompetensi || 0 }}</td>
                                    <td>{{ data_penilaian_akhir?.penilaian_akhir?.data_lama?.kompetensi?.bobot_kompetensi ? data_penilaian_akhir?.penilaian_akhir?.data_lama?.kompetensi?.bobot_kompetensi +'%' : 0 }}</td>
                                    <td>{{ data_penilaian_akhir?.penilaian_akhir?.data_lama?.kompetensi?.nilai_akhir_kompetensi || 0 }}</td>
                                  </tr>
                                  <tr
                                    class="border border-bottom-1 border-light"
                                  >
                                    <td>
                                      <div class="py-3 px-3">Penugasan Khusus, Rangkap Jabatan, Inovasi & Kreatifitas</div>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td>{{ data_penilaian_akhir?.penilaian_akhir?.data_lama?.penugasan_khusus || 0 }}</td>
                                  </tr>
                                  <tr
                                    class="border border-bottom-1 border-light"
                                  >
                                    <td>
                                      <div class="py-3 px-3">Faktor Pengurang KPI</div>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td>{{ data_penilaian_akhir?.penilaian_akhir?.data_lama?.pengurang || 0 }}</td>
                                  </tr>

                                </template>
                              </tbody>
                            </table>
                          </div>
                        </form-group>

                        <form-group>
                          <div class="table-responsive">
                            <table class="table align-middle border border-1 border-light">
                              <thead class="table-light">
                                <tr
                                  class="border border-bottom-1 border-light"
                                >
                                  <th scope="col" class="border-bottom-1 border-white">Nilai Akhir</th>
                                  <th scope="col" class="border-bottom-1 border-white" width="140">{{ data_penilaian_akhir?.penilaian_akhir?.data_lama?.nilai_akhir || 0 }}</th>
                                </tr>
                                <tr
                                  class="border border-bottom-1 border-light"
                                >
                                  <th scope="col">Indeks</th>
                                  <th scope="col">{{ data_penilaian_akhir?.penilaian_akhir?.data_lama?.indeks || '-' }}</th>
                                </tr>
                              </thead>
                            </table>
                          </div>
                        </form-group>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Tutup</button>
                        <!-- <button type="submit" class="btn btn-secondary">Simpan</button> -->
                      </div>
                    </div>
                  </div>
                </div>

                <form-group>
                  <div class="table-responsive">
                    <table class="table align-middle border border-1 border-light">
                      <thead class="table-light">
                        <tr>
                          <th scope="col">Kategori</th>
                          <th scope="col">Nilai</th>
                          <th scope="col">Bobot</th>
                          <th scope="col">Nilai Akhir</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-if="!data_penilaian_akhir"
                          class="border border-bottom-1 border-light"
                        >
                          <td colspan="4" class="text-center py-4">Data tidak ditemukan.</td>
                        </tr>

                        <template v-else>
                          <tr
                            class="border border-bottom-1 border-light"
                          >
                            <td>
                              <div class="py-3 px-3">Rata-rata Nilai Kinerja</div>
                            </td>
                            <td>{{ data_penilaian_akhir?.penilaian_akhir?.koreksi?.nilai_kinerja?.average_kinerja || 0 }}</td>
                            <td>{{ data_penilaian_akhir?.penilaian_akhir?.koreksi?.nilai_kinerja?.bobot_kinerja ? data_penilaian_akhir?.penilaian_akhir?.koreksi?.nilai_kinerja?.bobot_kinerja +'%' : 0 }}</td>
                            <td>{{ data_penilaian_akhir?.penilaian_akhir?.koreksi?.nilai_kinerja?.nilai_akhir_kinerja || 0 }}</td>
                          </tr>
                          <tr
                            class="border border-bottom-1 border-light"
                          >
                            <td>
                              <div class="py-3 px-3">Rata-rata Perilaku Kompetensi</div>
                            </td>
                            <td>{{ data_penilaian_akhir?.penilaian_akhir?.koreksi?.kompetensi?.average_kompetensi || 0 }}</td>
                            <td>{{ data_penilaian_akhir?.penilaian_akhir?.koreksi?.kompetensi?.bobot_kompetensi ? data_penilaian_akhir?.penilaian_akhir?.koreksi?.kompetensi?.bobot_kompetensi +'%' : 0 }}</td>
                            <td>{{ data_penilaian_akhir?.penilaian_akhir?.koreksi?.kompetensi?.nilai_akhir_kompetensi || 0 }}</td>
                          </tr>
                          <tr
                            class="border border-bottom-1 border-light"
                          >
                            <td>
                              <div class="py-3 px-3">Penugasan Khusus, Rangkap Jabatan, Inovasi & Kreatifitas</div>
                            </td>
                            <td></td>
                            <td></td>
                            <td>{{ data_penilaian_akhir?.penilaian_akhir?.koreksi?.penugasan_khusus || 0 }}</td>
                          </tr>
                          <tr
                            class="border border-bottom-1 border-light"
                          >
                            <td>
                              <div class="py-3 px-3">Faktor Pengurang KPI</div>
                            </td>
                            <td></td>
                            <td></td>
                            <td>{{ data_penilaian_akhir?.penilaian_akhir?.koreksi?.pengurang || 0 }}</td>
                          </tr>

                        </template>
                      </tbody>
                    </table>
                  </div>
                </form-group>

                <form-group>
                  <div class="table-responsive">
                    <table class="table align-middle border border-1 border-light">
                      <thead class="table-light">
                        <tr
                          class="border border-bottom-1 border-light"
                        >
                          <th scope="col" class="border-bottom-1 border-white">Nilai Akhir</th>
                          <th scope="col" class="border-bottom-1 border-white" width="140">{{ data_penilaian_akhir?.penilaian_akhir?.koreksi?.nilai_akhir || 0 }}</th>
                        </tr>
                        <tr
                          class="border border-bottom-1 border-light"
                        >
                          <th scope="col">Indeks</th>
                          <th scope="col">{{ data_penilaian_akhir?.penilaian_akhir?.koreksi?.indeks || '-' }}</th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                </form-group>

                <template v-if="['submission'].includes(status_koreksi)">
                  <div
                    v-if="!is_note_penilaian_akhir"
                    class="d-flex justify-content-end gap-4"
                  >
                    <button
                      type="button"
                      class="btn btn-outline-secondary"
                      @click="is_note_penilaian_akhir = !is_note_penilaian_akhir"
                    >
                      Berikan Catatan
                    </button>
                  </div>

                  <form-group
                    v-if="is_note_penilaian_akhir"
                    label="Tulis Catatan"
                  >
                    <p class="text-sm mb-2">Beri catatan untuk karyawan</p>
                    <textarea
                      v-model="note_penilaian_akhir"
                      class="form-control"
                      rows="5"
                      placeholder="Tulis catatan disini"
                    />
                  </form-group>
                </template>
              </div>

            </tabbed-pane>
          </cards>
        </GridCol>
      </GridRow>
    </div>
  </main>
</template>
    
<script>
import Cards from "@/components/CardComponent.vue";
import FormGroup from "@/components/FormGroup.vue";
// import FieldsetComponent from "@/components/FieldsetComponent.vue";
// import Select2 from 'vue3-select2-component';
import TabbedPane from "@/components/TabbedPane.vue";
// import ArgonButton from "@/components/ArgonButton.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";
import MetaSection from '@/components/MetaSection.vue';
import GridRow from "@/components/grid/GridRow.vue";
import GridCol from "@/components/grid/GridCol.vue";
// import InputForm from "@/components/InputForm.vue";

import KpiPeriodeApi from "@/repository/api/KpiPeriodeApi";
import EmployeeApi from "@/repository/api/EmployeeApi";
import KoreksiApi from "@/repository/api/KoreksiApi";
import PenilaianKpiApi from "@/repository/api/PenilaianKpiApi";


export default {
  name: "realisasi-target",
  components: {
    // FieldsetComponent,
    FormGroup,
    Cards,
    TabbedPane,
    // ArgonButton,
    ArgonAlert,
    MetaSection,
    GridRow,
    GridCol,
    // InputForm,
  },
  data() {
    return {
      tabs: {
        'Penilaian Kinerja':true,
        'Penugasan Khusus':false,
        'Pengurangan':false,
        'Kompetensi':false,
        'Penilaian Akhir':false
      },
      
      is_correction: false,

      periode_active: null,
      employee: null,
      employee_id_login: null,

      list_penilaian_kinerja: [],
      is_note_penilaian_kinerja: false,
      note_penilaian_kinerja: '',
      
      list_penugasan_khusus: [],
      is_note_penugasan_khusus: false,
      note_penugasan_khusus: '',

      list_pengurangan: [],
      is_note_pengurangan: false,
      note_pengurangan: '',

      list_kompetensi_inti: [],
      list_kompetensi_inti_old: [],

      list_kompetensi_manajerial: [],
      list_kompetensi_manajerial_old: [],

      is_note_kompetensi: false,
      note_kompetensi: '',

      realisasi_kompetensi: null,

      data_penilaian_akhir: null,
      is_note_penilaian_akhir: false,
      note_penilaian_akhir: '',
      satuan_target: [
        {
          value: 'rupiah',
          label: 'Rupiah'        
        },
        {
          value: 'persen',
          label: 'Persen/Hari/Skala Nilai'        
        },
        {
          value: 'pcs',
          label: 'Pcs'        
        }
      ],
    };
  },
  computed: {
    periode_id() {
      return this.$route.params?.periode_id;
    },
    employee_id() {
      return this.$route.params?.employee_id;
    },
    realization_id() {
      return this.$route.params?.realization_id;
    },
    status_koreksi() {
      return this.$route.params?.status_koreksi;
    },
    correction_id() {
      return this.$route.params?.correction_id;
    },
    total_nilai() {
      let total = 0;

      if (this.list_kompetensi_inti.length > 0) {
        this.list_kompetensi_inti.forEach(item => {
          total += item.nilai;
        });
      }

      if (this.list_kompetensi_manajerial.length > 0) {
        this.list_kompetensi_manajerial.forEach(item => {
          total += item.nilai;
        });
      }

      return total;
    },
    total_nilai_old() {
      let total = 0;

      if (this.list_kompetensi_inti_old.length > 0) {
        this.list_kompetensi_inti_old.forEach(item => {
          total += item.nilai;
        });
      }

      if (this.list_kompetensi_manajerial_old.length > 0) {
        this.list_kompetensi_manajerial_old.forEach(item => {
          total += item.nilai;
        });
      }

      return total;
    },
    
    nilai_kompetensi() {
      let total = 0;
      total = (this.total_nilai / this.max_jabatan) * 5;
      if (!Number.isInteger(total)) total = total.toFixed(2);
      return total;
    },
    
    nilai_kompetensi_old() {
      let total = 0;
      total = (this.total_nilai_old / this.max_jabatan) * 5;
      if (!Number.isInteger(total)) total = total.toFixed(2);
      return total;
    },
    max_jabatan() {
      let total = 0;
      let inti = this.employee?.jabatan?.inti || 0;
      let manajerial = this.employee?.jabatan?.manajerial || 0;

      total = (inti * 5) + (manajerial * 5);
      if (!Number.isInteger(total)) total = total.toFixed(2);
      return total;
    },
  },
  watch: {
    periode_id() {},
    employee_id() {},
    realization_id() {},
    status_koreksi() {},
    correction_id() {},
    total_nilai() {},
    total_nilai_old() {},
    nilai_kompetensi() {},
    nilai_kompetensi_old() {},
    max_jabatan() {},
  },
  methods: {
    // openNoteModal(index) {
      //   this.step_1_detail_index = index;
    // },
    sumBobotSubKpi(data) {
      data = data.map((item) => Number.parseFloat(item?.bobot || 0));
      data = data.reduce((a, b) => a + b, 0);
      return data;
    },
    setCorrection(is_correction=false) {
      if (!is_correction) {
        this.$swal({
          icon: "warning",
          title: "Perubahan data akan hilang, lanjutkan?",
          showCancelButton: true,
        }).then(async (result) => {
          if (result.isConfirmed) {
            this.getData();

            this.is_correction = is_correction;
            
            this.is_note_penilaian_kinerja = false;
            this.note_penilaian_kinerja = '';
            this.is_note_penugasan_khusus = false;
            this.note_penugasan_khusus = '';
            this.is_note_pengurangan = false;
            this.note_pengurangan = '';
            this.is_note_kompetensi = false;
            this.note_kompetensi = '';
            this.is_note_penilaian_akhir = false;
            this.note_penilaian_akhir = '';
          }
        });

      } else {
        this.is_correction = is_correction;
      }
    },
    async checkLimitInput(type, index) {
      this.$store.state.loading = true;

      await PenilaianKpiApi.checkLimitInput({
        employee_id: this.employee_id,
        type,
        // type: this.employee.jabatan.jenis_kompetensi,
        nilai: (type === 'inti' ? this.list_kompetensi_inti[index].nilai : this.list_kompetensi_manajerial[index].nilai),
      })
        .then((resp) => {
          console.log(resp)
        })
        .catch((err) => {
          console.log(err)
          if (err?.response?.status === 412) {

            this.$swal({
              icon: "warning",
              title: err?.response?.data?.message,
            });

            if (type === 'inti') this.list_kompetensi_inti[index].nilai = err?.response?.data?.data?.[0]?.inti || 0;
            else this.list_kompetensi_manajerial[index].nilai = err?.response?.data?.data?.[0]?.manajerial || 0;

          } else {

            this.$swal({
              icon: "warning",
              title: 'Something wrong, please try again.',
            });

            if (type === 'inti') this.list_kompetensi_inti[index].nilai = 0;
            else this.list_kompetensi_manajerial[index].nilai = 0;
          }
        });

      this.$store.state.loading = false;
    },

    async getKpiPeriode() {
      await KpiPeriodeApi.get(this.periode_id)
        .then((response) => {
          this.periode_active = response?.data || {};
        })
        .catch((err) => {
          console.log(err)
        });
    },
    async getEmployee() {
      await EmployeeApi.get(this.employee_id)
        .then((resp) => {
          this.employee = resp?.data;
        })
        .catch((err) => {
          console.log(err)
        });
      
      await this.getSessionUser();
      this.employee_id_login = this.$store.state?.sessionUser?.employee?.id || '';
    },
    async getPenilaianKinerja() {
      await KoreksiApi.getDetailHasilKoreksiPenilaianKinerja({
        realization_id: this.realization_id,
        correction_id: this.correction_id,
      })
        .then((resp) => {
          this.list_penilaian_kinerja = resp?.data;
        })
        .catch((err) => {
          console.log(err)
        });
    },

    async getPenugasanKhusus() {
      await KoreksiApi.getDetailHasilKoreksiPenugasanKhusus({
        realization_id: this.realization_id,
        correction_id: this.correction_id,
      })
        .then((resp) => {
          this.list_penugasan_khusus = resp?.data;
        })
        .catch((err) => {
          console.log(err)
        });
    },

    async getPengurangan() {
      await KoreksiApi.getDetailHasilKoreksiPengurangan({
        realization_id: this.realization_id,
        correction_id: this.correction_id,
      })
        .then((resp) => {
          this.list_pengurangan = resp?.data;
        })
        .catch((err) => {
          console.log(err)
        });
    },

    async getKompetensi() {
      await KoreksiApi.getDetailHasilKoreksiKompetensi({
        realization_id: this.realization_id,
        correction_id: this.correction_id,
      })
        .then((resp) => {
          this.realisasi_kompetensi = resp?.data || null;
          // const list = resp?.data ? resp.data.map(item => { item.nilai = 0; return item; }) : [];
          const list = resp?.data?.kompetensi?.nilai_perkompetensi;
          // console.log(list)

          if (list?.koreksi) {
            this.list_kompetensi_inti = list.koreksi.filter(item => item?.type === 'inti');
            this.list_kompetensi_manajerial = list.koreksi.filter(item => item?.type === 'manajerial');
          }

          if (list?.data_lama) {
            this.list_kompetensi_inti_old = list.data_lama.filter(item => item?.type === 'inti');
            this.list_kompetensi_manajerial_old = list.data_lama.filter(item => item?.type === 'manajerial');
          }

        })
        .catch((err) => {
          console.log(err)
        });
    },

    async getPenilaianAkhir() {
      await KoreksiApi.getDetailPenilaianAkhir({
        // employee_id: this.employee_id,
        realization_id: this.realization_id,
        correction_id: this.correction_id,
      })
        .then((resp) => {
          // console.log(resp?.data)
          this.data_penilaian_akhir = resp?.data || null;
        })
        .catch((err) => {
          console.log(err)
          // this.data_penilaian_akhir = err?.response?.data || null;
        });
    },

    async getData() {
      this.$store.state.loading = true;
  
      await this.getKpiPeriode();
      await this.getEmployee();
      await this.getPenilaianKinerja();
      await this.getPenugasanKhusus();
      await this.getPengurangan();
      await this.getKompetensi();
      await this.getPenilaianAkhir();
  
      this.$store.state.loading = false;
    },

    async submit(is_accept) {

      if (!is_accept && (!this.note_penilaian_kinerja && !this.note_penugasan_khusus && !this.note_pengurangan && !this.note_kompetensi && !this.note_penilaian_akhir)) {
        this.$swal({
          icon: "error",
          title: 'Catatan Dibutuhkan',
          text: 'Beri catatan pada salah satu komponen yang belum sesuai.',
        });

        return;
      }
      
      // console.log('prevent tolak/terima')
      // return;
      // eslint-disable-next-line no-unreachable
      this.$swal({
          icon: "warning",
          title: "Anda yakin ingin "+ (is_accept ? 'menerima' : 'menolak') +" koreksi?",
          showCancelButton: true,
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              this.$store.state.loading = true;

              // submit all note
              await this.submitNote(this.note_penilaian_kinerja, KoreksiApi.addNoteKoreksiPenilaianKinerja);
              await this.submitNote(this.note_penugasan_khusus, KoreksiApi.addNoteKoreksiPenugasanKhusus);
              await this.submitNote(this.note_pengurangan, KoreksiApi.addNoteKoreksiPengurangan);
              await this.submitNote(this.note_kompetensi, KoreksiApi.addNoteKoreksiKompetensi);
              await this.submitNote(this.note_penilaian_akhir, KoreksiApi.addNoteKoreksiPenilaianAkhir);
    
              // submit tolak/terima
              await KoreksiApi.submitKeputusan({
                correction_id: this.correction_id,
                keputusan: (is_accept ? 'accept' : 'reject') +'_immediate_supervisor',
                created_by: this.employee_id_login,
              })
                .then((resp) => {
                  console.log(resp)
                  
                  this.direct_leave = true;
                  this.$router.push({ name: 'Penilaian KPI' });
                })
                .catch((err) => {
                  // console.log(err)
                  throw err;
                });

              this.$swal({
                icon: "success",
                title: 'Koreksi berhasil di'+ (is_accept ? 'terima' : 'tolak') +'.',
              });

              this.$router.push({ name: 'Pengajuan Koreksi' });

              this.$store.state.loading = false;
              
            } catch (error) {
              console.log(error)
              this.$store.state.loading = false;
              this.$swal({
                icon: "error",
                title: error?.response?.data?.message || 'Something wrong, please try again.',
              });
            }
          }
        });
    },
    async submitNote(note, apiMethod) {
      if (!note) return;
      await apiMethod({
        correction_id: this.correction_id,
        is_from_immediate: true,
        catatan: note,
      }).catch((err) => {
        throw err;
      });
    },
    getSatuan(satuan) {
      let result = null
      try {
        result = this.satuan_target.find(({ value }) => value === satuan);
        result = result.label
      } catch (error) {
        result = satuan
      }
      return result
    }
  },
  async mounted() {
    await this.getData();
  },
};
</script>
    